import type { AlgoliaEventItem } from '~/composables/types/algolia'
import type { EventDescription } from '~/composables/types/event'

export const parseEventDescriptionToAlgoliaEventItem = (
  item: EventDescription
): Partial<AlgoliaEventItem> => {
  return {
    categories: eventGetters.getCategories(item),
    title: eventGetters.getTitle(item),
    default_duration: eventGetters.getDefaultDuration(item),
    default_price: eventGetters.getDefaultPriceObject(item),
    hashed_id: eventGetters.getId(item),
    images: eventGetters.getGallery(item),
    permalink: eventGetters.getPermalink(item),
    supplier: eventGetters.getSupplierName(item),
    next_event: eventGetters.getNextInstanceInTimestamp(item),
    rating: eventGetters.getReviewsRating(item),
    has_mobile_classes: eventGetters.getHasMobileClasses(item),
    main_image: {
      alt: eventGetters.getFirstImageAlt(item),
      thumb: eventGetters.getFirstThumb(item),
    },
    has_promotions: eventGetters.getHasPromotion(item),
    original_price: eventGetters.getOriginalPrice(item),
    type: eventGetters.getAttendanceMode(item),
    min_number_of_people: item.min_number_of_people ?? 0,
    max_number_of_people: item.max_number_of_people ?? 0,
    has_shipping_costs: item.has_shipping_costs ?? 0,
    team_event_only: eventGetters.getIsTeamEvent(item),
  }
}

export const transformToAlgoliaEvent = (data: { data: EventDescription[] }) =>
  (data?.data || []).map(parseEventDescriptionToAlgoliaEventItem)
